/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    v-if="loaded"
    class="row"
  >
    <div
      class="col-sm-6 col-sm-offset-3"
      aria-labelledby="confirmInviteCode"
    >
      <h1 id="confirmInviteCode">
        Confirm Invite Code
      </h1>
      <div
        v-if="this.$route.query.code"
        class="form-group"
        role="alert"
      >
        Confirm you wish to join the
        <span v-if="isEdu">
          class
        </span>
        <span v-if="!isEdu">
          group
        </span>
        associated with invite code "<span>{{ this.$route.query.code }}</span>":
        <br><br><br>
        <button
          class="btn clear-btn"
          @click="cancelInvite()"
        >
          Cancel
        </button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button
          class="btn btn-primary"
          @click="loadInvite()"
        >
          Join Group
        </button>
      </div>
      <div
        v-else-if="this.$route.query.invite"
        class="form-group"
        role="alert"
      >
        The invite code you are attempting to use cannot be applied to an
        existing account. Please contact support at support@bigtincan.com
        to have this code applied to your account.
      </div>
      <div
        v-else
        class="form-group"
        role="alert"
      >
        You appear to have reached this page in error. Click on the menu above to proceed to your account.
      </div>
    </div>
  </div>
</template>

<script>
import BasePage from './BasePage';

export default {
  mixins: [BasePage],
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    isEdu() {
      return this.$store.getters.org && this.$store.getters.org.type == 'edu';
    },
  },
  methods: {
    basePageCreated() {
      if (this.$route.query.code) {
        this.$store.dispatch('getInvite', {inviteCode: this.$route.query.code})
          .then((invite) => {
            const groups = this.$store.getters.activeGroups;
            let alreadyInGroup = false;
            let managerInGroup = false;
            let speakerInGroup = false;

            groups.forEach((group) => {
              if (group.groupId === invite.roles[0].groupId) {
                alreadyInGroup = true;
                managerInGroup = (group.roles.indexOf('manager') !== -1);
                speakerInGroup = (group.roles.indexOf('speaker') !== -1);
              }
            });

            if (alreadyInGroup && managerInGroup && !speakerInGroup) {
              window.setTimeout(
                () => {
                  this.$store.dispatch('notify', {
                    type: 'error',
                    subject: (this.isEdu) ?
                      'You are already an Instructor in this Class' :
                      'You are already a Coach in this Group',
                    text: (this.isEdu) ?
                      'When you are an instructor for a class, you cannot also be a student in that class.' :
                      'When you are a coach for a group, you cannot also be a speaker in that group.'
                  });
                }, 1000
              );
            }

            if (alreadyInGroup) {
              this.$store.dispatch('resetSignInLink');
              return this.$router.push({path: this.homepage});
            }
          }).finally(() => {
            this.loaded = true;
          });
      } else {
        this.$router.push({ name: this.homepage });
      }
    },
    cancelInvite() {
      this.$store.dispatch('resetSignInLink');
      this.$router.push({ name: this.homepage });
    },
    loadInvite() {
      let groupId = null;

      this.$store.dispatch('joinGroup', {inviteCode: this.$route.query.code})
        .then((data) => {
          groupId = data['groupId'];
          if (!groupId) {
            return this.$router.push({ path: this.homepage });
          }
          return this.$store.dispatch('listGroups');
        })
        .then(() => {
          if (groupId) {
            this.$store.dispatch('resetSignInLink');
            this.$router.push({path: `subscription/${groupId}`});
          }
        })
        .catch((data) => {
          this.$store.dispatch('resetSignInLink');
          this.$router.push({ path: this.homepage });
          window.setTimeout(
            () => {
              if (data && data[0] && data[0].$status === 402) {
                return this.$store.dispatch('notify', {
                  type: 'error',
                  subject: 'Could not save changes',
                  text: 'The organization you are trying to join ' +
                    'has reached its maximum number of licenses. ' +
                    'Please contact your manager or VoiceVibes administrator to ' +
                    'request access.',
                });
              }

              this.$store.dispatch('notify', {
                type: 'error',
                subject: 'Invite Code Invalid',
                text: (data[0] && data[0].message) ? data[0].message :
                  'The invite code could not be loaded. Please ensure it is a valid code associated with your current organization'
              });
            }, 1000
          );
        });
    }
  },
};
</script>
